import React from 'react'
import { useNavigate } from 'react-router-dom'
import StepsContext, { IStepsContext } from '../../contexts/StepsContext'

function useStep(): {
	nextStep: () => IStepsContext
	returnStep: () => IStepsContext
} {
	const navigate = useNavigate()
	const context = React.useContext(StepsContext)
	function nextStep(): IStepsContext {
		const questions = context.steps[context.currentStep]
		if (context.currentQuestion + 1 === questions.questions.length) {
			context.setCurrentStep(context.currentStep + 1)
			context.setCurrentQuestion(0)
		} else {
			context.setCurrentQuestion(context.currentQuestion + 1)
		}
		return context
	}
	function returnStep(): IStepsContext {
		if (context.currentQuestion === 0 && context.currentStep === 0) {
			const header = document.querySelector('.menu')
			if (header) {
				header.classList.remove('header--margin-left', 'header--centralize')
			}
			navigate('/instrucoes')
		}
		if (context.currentQuestion === 0) {
			context.setCurrentStep(context.currentStep - 1)
			context.setCurrentQuestion(4)
		} else {
			context.setCurrentQuestion(context.currentQuestion - 1)
		}
		return context
	}
	return { nextStep, returnStep }
}
export default useStep
